import * as React from "react"

import { cn } from "@/lib/utils"

type DivProps = React.ComponentProps<"div">

function ResponsiveList({ className, ...props }: DivProps) {
  return <div data-slot="responsive-list" className={className} {...props} />
}

function ResponsiveListDesktop({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="responsive-list-desktop"
      className={cn("hidden md:block", className)}
      {...props}
    />
  )
}

function ResponsiveListMobile({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="responsive-list-mobile"
      className={cn("md:hidden", className)}
      {...props}
    />
  )
}

ResponsiveList.Desktop = ResponsiveListDesktop
ResponsiveList.Mobile = ResponsiveListMobile

export { ResponsiveList }
